export { SkyPageSummaryImageComponent } from './page-summary-image.component';
